export const MAX_TYPE_LENGTH = 23;
export const TABLET_TYPE_LENGTH = 4;
export const DESKTOP_TYPE_LENGTH = 5;

export const diffMobileHeader = ["/qr-creator", "/", "/url-to-qr-code", '/create-free-qr-code', '/qr-code-generator', '/qr-generator', '/solutions/dynamic-url-qr-code'];
export const month = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const designForRender = {
  qrShape: "qrShape",
  sticker: "sticker",
  color: "color",
  shape: "shape",
  logo: "logo",
  decorate: "decorate",
};

export const neededPathnamesForGenerate = [
  "/",
  "/qr-code-generator",
  "/solutions/",
  "/for-iframe",
  "/qr-creator",
  "/qr-generator",
  "/create-free-qr-code",
  "/url-to-qr-code",
  "/qrfast",
];

export const socialItemsUrl = {
  facebook: "www.facebook.com",
  instagram: "www.instagram.com",
  linkedin: "www.linkedin.com",
  website: "www.website.com",
  twitter: "www.twitter.com",
  youtube: "www.youtube.com",
  whatsapp: "www.whatsApp.com",
  telegram: "www.telegram.com",
  snapchat: "www.snapchat.com",
  tiktok: "www.tiktok.com",
};

export const dashboardStepsUrl = [
  "/dashboard/builder/steps/setup",
  "/dashboard/builder/steps/design",
  "/dashboard/builder",
  "/dashboard/builder/steps/customize",
];

export enum VARIANT {
  VariantA = "A",
  VariantB = "B",
  VariantC = "C",
  VariantD = "D",
  VariantE = "E",
}

export enum LocaleLang {
  en = "en",
  nl = "nl",
  be = "be",
}

export const VALIDATELIMIT = {
  url: 2000,
  full_name: 100,
  phone: 15,
  email: 254,
  company: 160,
  job: 60,
  street: 255,
  street_number: 10,
  city: 190,
  state: 255,
  zip: 18,
  summary: 255,
};

export enum UrlValidations {
  invalidUrl = "validations.invalidUrl",
  required = "validations.required",
}

export const urlRegex =
  /^(https?:\/\/)?([a-zA-Z0-9\-._~%!$&'()*+,;=]+@)?((\[[0-9a-fA-F:.]+\])|(([a-zA-Z0-9\-._~%]+)\.([a-zA-Z]{2,})))?(:\d{2,5})?(\/[a-zA-Z0-9\-._~%!$&'()*+,;=:@]*)*(\?[a-zA-Z0-9\-._~%!$&'()*+,;=:@\/?]*)?(\#[a-zA-Z0-9\-._~%!$&'()*+,;=:@\/?]*)?$/;

export const freemiumPlanUuid = "free";

export const maxFileUploadSize = 31457280; // means 30 MB

export const helpCenterLink = "https://help.qrcodecreator.com/";
export const logoAltImg = "qrcodecreator";

export const TRACKABLE = "1";

export const NONTRACKABLE = "0";

export const ACTIVE = 1;

export const PAUSE = 2;
export const HOME_DEFAULT_HEADING_TEXT = "Free QR Code Generator Online";
export const DASHBOARD_STEP_SELECT_URL = "/dashboard/builder";
export const ACTIVATE_QR_TEXT = `Now you are one “Activate” button away from your goal. Do you want
to proceed with activation?`;

export const PAUSE_QR_TEXT = `Pause QR Codes to deactivate and make them inaccessible for your customers. If you
need to use the paused codes again, you can easily reactivate them.`;

export const SITE_DOMAIN = process.env.NEXT_PUBLIC_API_URL;

export const SITE_ICON_URL = `${SITE_DOMAIN}/resources/images/type-icons/`;

export const KEYBOARD_ENTER = "Enter";

export const DEFAULT_LOCATION = "212 Rey St, San Francisco CA 80203 ";

export const CREATION_UNDERWAY = `The creation process is already underway`;

export const CREATING_PROCESS = `QR code creation is in progress`;

export const QR_CAN_BE_DOWNLOADED = `Once your QR codes are prepared for download, we'll promptly notify you via email. Rest assured, even if you're generating numerous QR codes, you'll be able to download them all in just a few minutes.`;

export const NO_FOLDER = "No folder";

export const YOUR_QR_CODE = "Your QR Code name";

export const SAVE_SUCCESS_TEXT = `Success! You changes have been saved. It may take up to 1 minute to appear.`;

export const DOWNLOAD_SUCCESS_TEXT = `Your QR Code is being downloaded.`;

export const VIEWER_ACCESS_ERROR_TEXT = `You can’t perform this action on this page. Please contact your account admin.`;

export const OPEN_NOW = "Open now";

export const BLOG_REVALIDATE_TYPE = 200;

export const BUILDER_CONTENT_MAIN_CSS = `content-builder/assets/minimalist-blocks/content.css`;

export const BUILDER_CONTENT_DEFAULT_CSS = `content-builder/assets/minimalist-blocks/default.css`;

export const PLAN_ADVANCE = `Advanced`;

export const PLAN_PROF = `Professional`;

export const PLAN_BASIC = `Basic`;

export const FREE_TRIAL_DAYS = 7;

export enum InputType {
  Text = "text",
  Number = "number",
  Password = "password",
  Email = "email",
  Date = "date",
  Checkbox = "checkbox",
  Radio = "radio",
  File = "file",
  Tel = "tel",
  Range = "range",
  Button = "button",
  Url = "url",
}

export const forRender = {
  text: "TEXT",
  vcard: "VCARD",
  sms: "SMS",
  email: "EMAIL",
  wifi: "WIFI",
  call: "CALL",
  mp3: "MP3",
  url: "URL",
  app: "APP",
  bitcoin: "BITCOIN",
  feedback: "FEEDBACK",
  facebook: "FACEBOOK",
  linkedin: "LINKEDIN",
  pdf: "PDF",
  menu: "MENU",
  raiting: "RATING",
  location: "LOCATION",
  video: "VIDEO",
  images: "IMAGES",
  business: "BUSINESSPAGE",
  coupon: "COUPON",
  social: "SOCIALMEDIA",
  event: "EVENT",
  multi: "MULTI",
};

export enum ReducerQrFilterType {
  cryptowallet = "cryptowallet",
  bitcoin = "bitcoin",
}

export const mobileLandingPageTypes = [
  {
    dashboardTypeTitle: "Website",
    landingPageTitle: "Website",
    desc_title: "URL",
    description: "Link to any web page",
    type: "url",
    typePath: "Url",
    url: "/solutions/dynamic-url-qr-code",
    metaTitle: "Dynamic URL to QR Code | QR Code Creator",
    metaDesc:
      "Use a QR Code Creator to transform your URL into QR Codes. Edit and update them easily.",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "PDF",
    landingPageTitle: "PDF",
    type: "pdf",
    typePath: "Pdf",
    desc_title: "PDF",
    description: "Share any PDF file with larger audiences",
    url: "/solutions/pdf",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Email",
    landingPageTitle: "Email",
    type: "email",
    typePath: "Email",
    desc_title: "Email",
    description: "Send and receive emails",
    url: "/solutions/email",
    headingText: "Generate QR Codes for Email - Try it for Free!",
    metaTitle: "Free QR Code Creator for Email | Instantly Connect with QR Codes",
    metaDesc:
      "Create QR codes for email effortlessly and for free. Easily connect with your audience through email with our user-friendly QR code generator. Get started now!",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Social Media",
    landingPageTitle: "Social Media",
    type: "socialmedia",
    typePath: "SocialMedia",
    desc_title: "Social Media",
    description: "Link to your social media accounts",
    url: "/solutions/social-media",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "VCard",
    landingPageTitle: "vCard",
    type: "vcard",
    typePath: "Vcard",
    desc_title: "VCard",
    description: "Share your contact details",
    url: "/solutions/vcard",
    isCustomize: true,
  },

  {
    dashboardTypeTitle: "SMS",
    landingPageTitle: "SMS",
    type: "sms",
    typePath: "Sms",
    desc_title: "SMS",
    description: "Send or receive text messages",
    url: "/solutions/sms",
    isCustomize: false,
  },

  {
    dashboardTypeTitle: "Text",
    landingPageTitle: "Text",
    type: "text",
    typePath: "Text",
    desc_title: "Text",
    description: "Share your stories, messages, opinions",
    url: "/solutions/text",
    isCustomize: false,
  },

  {
    dashboardTypeTitle: "Facebook",
    landingPageTitle: "Facebook",
    type: "facebook",
    typePath: "Facebook",
    desc_title: "Facebook",
    description: "Make your social media profile scanable and get more likes",
    url: "/solutions/facebook",
    isCustomize: true,
  },

  {
    dashboardTypeTitle: "Phone",
    landingPageTitle: "Phone",
    type: "call",
    typePath: "Call",
    desc_title: "Phone",
    description: "Receive phone calls",
    url: "/solutions/call",
    isCustomize: false,
  },

  {
    dashboardTypeTitle: "Video",
    landingPageTitle: "Video",
    type: "video",
    typePath: "Video",
    desc_title: "Video",
    description: "Share one or more videos  ",
    url: "/solutions/video",
    isCustomize: true,
  },

  {
    dashboardTypeTitle: "Menu",
    landingPageTitle: "Menu",
    type: "menu",
    typePath: "Menu",
    desc_title: "Menu",
    description: "Enable contactless and eco-friendly menus",
    url: "/solutions/menu",
    isCustomize: false,
  },

  {
    dashboardTypeTitle: "Linkedin",
    landingPageTitle: "Linkedin",
    type: "linkedin",
    typePath: "Linkedin",
    desc_title: "LinkedIn",
    description: "Link to your LinkedIn profile for effective networking",
    url: "/solutions/linkedin",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "App",
    landingPageTitle: "App",
    type: "app",
    typePath: "App",
    desc_title: "App",
    description: "Redirect the target audience to your app on various App Stores",
    url: "/solutions/app",
    isCustomize: true,
  },

  {
    dashboardTypeTitle: "Event",
    landingPageTitle: "Event",
    type: "event",
    typePath: "Event",
    desc_title: "Event",
    description: "Promote your event easily",
    url: "/solutions/event",
    isCustomize: true,
  },

  {
    dashboardTypeTitle: "WiFi",
    landingPageTitle: "WiFi",
    type: "wifi",
    typePath: "Wifi",
    url: "wifi",
    isCustomize: false,
    untracking: true,
  },
  {
    dashboardTypeTitle: "Location",
    landingPageTitle: "Location",
    type: "location",
    typePath: "Location",
    desc_title: "Location",
    description: "Show your location using an innovative way.",
    url: "/solutions/location",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Images",
    landingPageTitle: "Images",
    type: "images",
    typePath: "Images",
    desc_title: "Images",
    description: "Share your images faster ",
    url: "/solutions/images",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "MP3",
    landingPageTitle: "MP3",
    type: "mp3",
    typePath: "Mp3",
    desc_title: "MP3",
    description: "Maximize the sharing of your audio content ",
    url: "/solutions/mp3",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "Rating",
    landingPageTitle: "Rating",
    type: "rating",
    typePath: "Rating",
    desc_title: "Rating",
    description: "Get more customer reviews and boost your ratings ",
    url: "/solutions/rating",
    isCustomize: false,
  },

  {
    dashboardTypeTitle: "Business Page",
    landingPageTitle: "Business page",
    type: "businesspage",
    typePath: "BusinessPage",
    desc_title: "Business Page",
    description: "Redirect your audience to your business page",
    url: "/solutions/business",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "Feedback",
    landingPageTitle: "Feedback",
    type: "feedback",
    typePath: "FeedBack",
    desc_title: "Feedback",
    description: "Collect feedback effortlessly ",
    url: "/solutions/feedback",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Coupon",
    landingPageTitle: "Coupon",
    type: "coupon",
    typePath: "Coupon",
    desc_title: "Coupon",
    description: "Deliver discounts and offers to your customers ",
    url: "/solutions/coupon",
    isCustomize: true,
  },

  {
    dashboardTypeTitle: "Crypto Wallet",
    landingPageTitle: "Crypto wallet",
    type: "bitcoin",
    typePath: "Bitcoin",
    desc_title: "Crypto Wallet",
    description: "Make your crypto transactions easier",
    url: "/solutions/bitcoin",
    isCustomize: false,
    untracking: true,
  },
];

export const landingPageTypes = [
  {
    dashboardTypeTitle: "Website",
    landingPageTitle: "Website",
    desc_title: "URL",
    description: "Link to any web page",
    type: "url",
    typePath: "Url",
    url: "/solutions/dynamic-url-qr-code",
    metaTitle: "Dynamic URL to QR Code | QR Code Creator",
    metaDesc:
      "Use a QR Code Creator to transform your URL into QR Codes. Edit and update them easily.",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "PDF",
    landingPageTitle: "PDF",
    type: "pdf",
    typePath: "Pdf",
    desc_title: "PDF",
    description: "Share any PDF file with larger audiences",
    url: "/solutions/pdf",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Email",
    landingPageTitle: "Email",
    type: "email",
    typePath: "Email",
    desc_title: "Email",
    description: "Send and receive emails",
    url: "/solutions/email",
    headingText: "Generate QR Codes for Email - Try it for Free!",
    metaTitle: "Free QR Code Creator for Email | Instantly Connect with QR Codes",
    metaDesc:
      "Create QR codes for email effortlessly and for free. Easily connect with your audience through email with our user-friendly QR code generator. Get started now!",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Social Media",
    landingPageTitle: "Social media",
    type: "socialmedia",
    typePath: "SocialMedia",
    desc_title: "Social Media",
    description: "Link to your social media accounts",
    url: "/solutions/social-media",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "VCard",
    landingPageTitle: "VCard",
    type: "vcard",
    typePath: "Vcard",
    desc_title: "VCard",
    description: "Share your contact details",
    url: "/solutions/vcard",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "SMS",
    landingPageTitle: "SMS",
    type: "sms",
    typePath: "Sms",
    desc_title: "SMS",
    description: "Send or receive text messages",
    url: "/solutions/sms",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Text",
    landingPageTitle: "Text",
    type: "text",
    typePath: "Text",
    desc_title: "Text",
    description: "Share your stories, messages, opinions",
    url: "/solutions/text",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Facebook",
    landingPageTitle: "Facebook",
    type: "facebook",
    typePath: "Facebook",
    desc_title: "Facebook",
    description: "Make your social media profile scanable and get more likes",
    url: "/solutions/facebook",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "Video",
    landingPageTitle: "Video",
    type: "video",
    typePath: "Video",
    desc_title: "Video",
    description: "Share one or more videos  ",
    url: "/solutions/video",
    isCustomize: true,
  },

  {
    dashboardTypeTitle: "LinkedIn",
    landingPageTitle: "LinkedIn",
    type: "linkedin",
    typePath: "Linkedin",
    desc_title: "LinkedIn",
    description: "Link to your LinkedIn profile for effective networking",
    url: "/solutions/linkedin",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Phone",
    landingPageTitle: "Phone",
    type: "call",
    typePath: "Call",
    desc_title: "Phone",
    description: "Receive phone calls",
    url: "/solutions/call",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "WiFi",
    landingPageTitle: "WiFi",
    type: "wifi",
    typePath: "Wifi",
    url: "wifi",
    isCustomize: false,
    untracking: true,
  },
  {
    dashboardTypeTitle: "Location",
    landingPageTitle: "Location",
    type: "location",
    typePath: "Location",
    desc_title: "Location",
    description: "Show your location using an innovative way.",
    url: "/solutions/location",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Event",
    landingPageTitle: "Event",
    type: "event",
    typePath: "Event",
    desc_title: "Event",
    description: "Promote your event easily",
    url: "/solutions/event",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "App",
    landingPageTitle: "App",
    type: "app",
    typePath: "App",
    desc_title: "App",
    description: "Redirect the target audience to your app on various App Stores",
    url: "/solutions/app",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "Images",
    landingPageTitle: "Images",
    type: "images",
    typePath: "Images",
    desc_title: "Images",
    description: "Share your images faster ",
    url: "/solutions/images",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "Menu",
    landingPageTitle: "Menu",
    type: "menu",
    typePath: "Menu",
    desc_title: "Menu",
    description: "Enable contactless and eco-friendly menus",
    url: "/solutions/menu",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "MP3",
    landingPageTitle: "MP3",
    type: "mp3",
    typePath: "Mp3",
    desc_title: "MP3",
    description: "Maximize the sharing of your audio content ",
    url: "/solutions/mp3",
    isCustomize: true,
  },

  {
    dashboardTypeTitle: "Rating",
    landingPageTitle: "Rating",
    type: "rating",
    typePath: "Rating",
    desc_title: "Rating",
    description: "Get more customer reviews and boost your ratings ",
    url: "/solutions/rating",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Bus. Page",
    landingPageTitle: "Bus. Page",
    type: "businesspage",
    typePath: "BusinessPage",
    desc_title: "Business Page",
    description: "Redirect your audience to your business page",
    url: "/solutions/business",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "Feedback",
    landingPageTitle: "Feedback",
    type: "feedback",
    typePath: "FeedBack",
    desc_title: "Feedback",
    description: "Collect feedback effortlessly ",
    url: "/solutions/feedback",
    isCustomize: false,
  },
  {
    dashboardTypeTitle: "Coupon",
    landingPageTitle: "Coupon",
    type: "coupon",
    typePath: "Coupon",
    desc_title: "Coupon",
    description: "Deliver discounts and offers to your customers ",
    url: "/solutions/coupon",
    isCustomize: true,
  },
  {
    dashboardTypeTitle: "Crypto W.",
    landingPageTitle: "Crypto W.",
    type: "bitcoin",
    typePath: "Bitcoin",
    desc_title: "Crypto Wallet",
    description: "Make your crypto transactions easier",
    url: "/solutions/bitcoin",
    isCustomize: false,
    untracking: true,
  },
];

export const cardBrandTypes = {
  VISA: "visa",
  MASTER_CARD: "mastercard",
  MAESTRO: "maestro",
  AMEX: "amex",
  CIRCUS: "circus",
  PAYPAL: "paypal",
};

export const paginationSelectPicker = [
  { label: "10 / Page", value: 10 },
  { label: "25 / Page", value: 25 },
  { label: "50 / Page", value: 50 },
  { label: "100 / Page", value: 100 },
];

export const analyticFilterParams = [
  {
    type: "hour",
    text: "Hour",
  },
  {
    type: "day",
    text: "Day",
  },
  {
    type: "month",
    text: "Month",
  },
];

export const analyticsTableHeader = [
  {
    id: 1,
    width: 186,
    title: "Time",
    dataKey: "created_at",
  },
  {
    id: 2,
    width: 256,
    title: "Country",
    dataKey: "country",
  },
  {
    id: 3,
    width: 226,
    title: "City",
    dataKey: "city",
  },
  {
    id: 4,
    width: 246,
    title: "Browser",
    dataKey: "browser",
  },
  {
    id: 5,
    width: 100,
    title: "OS",
    dataKey: "os",
  },
  {
    id: 6,
    width: 100,
    title: "",
    dataKey: "",
  },
];

export const analyticsCountryCodes = {
  UNKNOWN: "Unknown",
};

export const emailPattern =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const fileTypes = ["png", "jpg", "svg", "eps"];
export const defaultFileFormat = "png";
export const defaultFileFormatDesktop = "jpg";
export const defaultFileSize = 1024;

export const fileSizes = [512, 1024, 2048, 4096];

export const qrCodeStatus: Record<string, number> = {
  ACTIVE: 1,
  PAUSE: 2,
};

export enum stepTypes {
  SETUP = "setup",
  CUSTOMIZE = "customize",
  DESIGN = "design",
}

export const SignupModalIds = {
  A: {
    btn_signup_modal_register: "btn_signup_modal_register_a",
    btn_signup_modal_with_google: "btn_signup_modal_with_google_a",
    btn_signup_modal_with_microsoft: "btn_signup_modal_with_microsoft_a",
    btn_signup_modal_form_submit: "btn_signup_modal_form_submit_a",
    signup_modal_wrapper: "signup_modal_wrapper_a",
  },
  B: {
    btn_signup_modal_register: "btn_signup_modal_register_b",
    btn_signup_modal_with_google: "btn_signup_modal_with_google_b",
    btn_signup_modal_with_microsoft: "btn_signup_modal_with_microsoft_b",
    btn_signup_modal_form_submit: "btn_signup_modal_form_submit_b",
    signup_modal_wrapper: "signup_modal_wrapper_b",
  },
  C: {
    btn_signup_modal_register: "btn_signup_modal_register_c",
    btn_signup_modal_with_google: "btn_signup_modal_with_google_c",
    btn_signup_modal_with_microsoft: "btn_signup_modal_with_microsoft_c",
    btn_signup_modal_form_submit: "btn_signup_modal_form_submit_c",
    signup_modal_wrapper: "signup_modal_wrapper_c",
  },
  D: {
    btn_signup_modal_register: "btn_signup_modal_register_d",
    btn_signup_modal_with_google: "btn_signup_modal_with_google_d",
    btn_signup_modal_with_microsoft: "btn_signup_modal_with_microsoft_d",
    btn_signup_modal_form_submit: "btn_signup_modal_form_submit_d",
    signup_modal_wrapper: "signup_modal_wrapper_d",
  },
  E: {
    btn_signup_modal_register: "btn_signup_modal_register_e",
    btn_signup_modal_with_google: "btn_signup_modal_with_google_e",
    btn_signup_modal_with_microsoft: "btn_signup_modal_with_microsoft_e",
    btn_signup_modal_form_submit: "btn_signup_modal_form_submit_e",
    signup_modal_wrapper: "signup_modal_wrapper_e",
  },
};

export const maxHomepageTextTypeLimit = 500;

export const mobileHomeTabs = [
  { id: 1, title: "addContent", titleForWebType: "titleForWebType" },
  { id: 2, title: "designQrCode" },
];

export const googleTagEventsType = {
  Download: {
    event: "click",
    event_category: "Home Page Download Clicks",
    event_label: "Download Button",
  },
  SignInWithGoogle: {
    event: "click",
    event_category: "Home Page Overlay Clicks",
    event_label: "Sign in with Google on Overlay",
  },
  SignInWithAnEmail: {
    event: "click",
    event_category: "Home Page Overlay Clicks",
    event_label: "Sign in with Email on Overlay",
  },

  SignInWithGooglePopup: {
    event: "click",
    event_category: "Home Page Signup Pop-up",
    event_label: "Sign in with Google on Pop-up",
  },
  SignInWithAnEmailPopup: {
    event: "click",
    event_category: "Home Page Signup Pop-up",
    event_label: "Sign in with email on Pop-up",
  },
  ClosePopup: {
    event: "click",
    event_category: "Home Page Signup Pop-up",
    event_label: "Close Pop-up",
  },
};
